import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import NewClassSizeInput from '../../../Component/SettingComponent/NewClassSizeInput';
import NewClassTypeInput from '../../../Component/SettingComponent/NewClassTypeInput';
import NewCoachSelectBox from '../../../Component/SettingComponent/NewCoachSelectBox';
import NewColorChoice from '../../../Component/SettingComponent/NewColorChoice';
import NewCountInput from '../../../Component/SettingComponent/NewCountInput';
import NewLessonNameInput from '../../../Component/SettingComponent/NewLessonNameInput';
import AutoCancelSelectBox from '../../../Component/SettingComponent/AutoCancelUnitSelectBox';
import LessonHideSelectBox from '../../../Component/SettingComponent/LessonHideSelectBox';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

export default function LessonEditBox(props) {
  const { clickEditLessonData, isClickedLessonEdit, onClickExitAddLessonEdit, onSave } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  // const [isLessonUnVisible, setIsLessonUnVisible] = useState(false);
  const [isUseAutoCancel, setIsUseAutoCancel] = useState(false);
  const [id, setId] = useState(-1);
  const [lessonName, setLessonName] = useState('');
  const [lessonType, setLessonType] = useState('Offline');
  const [lessonSize, setLessonSize] = useState('Group');
  const [maxBookedCount, setMaxBookedCount] = useState(0);
  const [deduction, setDeduction] = useState(1);
  const [teacherData, setTeacherData] = useState([]);
  const [teacherId, setTeacherId] = useState(-1);
  const [time, setTime] = useState(0);
  const [selectedColor, setSelectedColor] = useState('#F4A1A9');
  const [standardTime, setStandardTime] = useState(0);
  const [standardUnit, setStandardUnit] = useState('시간');
  const [standardReserveCount, setStandardReserveCount] = useState(0);
  const [isHide, setIsHide] = useState(false);

  const [translateX, setTranslateX] = useState(495);

  // 수정 및 추가 버튼 클릭시 오른쪽에서 날라오기 에니매이션 //
  useEffect(() => {
    if (isClickedLessonEdit) setTranslateX(-495);
    else setTranslateX(60);
  }, [isClickedLessonEdit])

  // 데이터 수정 및 추가시 세팅 //
  useEffect(() => {

    // 수정이 아닌 추가일 경우 처음 데이터 세팅 //
    if (clickEditLessonData === undefined) {
      setId(-1);
      // setIsLessonUnVisible(false);
      setLessonName('');
      setLessonType('Offline');
      setLessonSize('Group');
      setMaxBookedCount(0);
      setTeacherData([]);
      setTeacherId(-1);
      setTime(0);
      setDeduction(1);
      setSelectedColor('#F4A1A9');
      setIsUseAutoCancel(false);
      setStandardUnit('시간');
      setStandardTime(0);
      setStandardReserveCount(0);
      setIsHide(false);
    }
    // 수정일 경우 기존 데이터 세팅 //
    else {
      setId(clickEditLessonData.id);
      // setIsLessonUnVisible(clickEditLessonData.isHide);
      setLessonName(clickEditLessonData.name);
      setLessonType(clickEditLessonData.type);
      setLessonSize(clickEditLessonData.size);
      setMaxBookedCount(clickEditLessonData.maxBookedPeople);
      setTeacherId(clickEditLessonData.teacherIds);
      setTime(clickEditLessonData.time);
      setDeduction(clickEditLessonData.deduction);
      setSelectedColor(clickEditLessonData.color);
      setIsUseAutoCancel(clickEditLessonData.isUseAutoCancel);
      setStandardUnit();
      setStandardTime(clickEditLessonData.standardTime);
      setStandardReserveCount(clickEditLessonData.standardReserveCount);
      setIsHide(clickEditLessonData.isHide);

      let finalStandardUnit = '시간';

      if (clickEditLessonData.standardUnit === 'Day') finalStandardUnit = '일';
      else if (clickEditLessonData.standardUnit === 'Hour') finalStandardUnit = '시간';
      else if (clickEditLessonData.standardUnit === 'Minute') finalStandardUnit = '분';

      setStandardUnit(finalStandardUnit);
    }
    // console.log(clickEditLessonData);
  }, [clickEditLessonData])

  // 저장버튼 클릭시 //
  function onClickSave() {

    let teacherIdList = [];

    teacherData.map((newData) => (
      teacherIdList.push(newData.id)
    ))

    let teacherIds = '';

    for (let i = 0; i < teacherIdList.length; i++) {
      if (i === 0) teacherIds += teacherIdList[i];
      else teacherIds += ',' + teacherIdList[i];
    }

    if (teacherIds === '') {
      alert(t('settingClasses.alertSelectCoach'));
      return;
    }
    else if (lessonName === '') {
      alert(t('settingClasses.alertEnterName'));
      return;
    }

    let finalStandardUnit = 'Hour';

    if (standardUnit === '일') finalStandardUnit = 'Day';
    else if (standardUnit === '분') finalStandardUnit = 'Minute';

    let requestData = {
      id: id === -1 ? undefined : id,
      storeId: 0,
      categoryId: 0,
      teacherIds: teacherIds,
      name: lessonName,
      time: time,
      maxBookedPeople: maxBookedCount,
      type: lessonType,
      size: lessonSize,
      deduction: deduction,
      color: selectedColor,
      isHide: isHide,
      isUseAutoCancel: isUseAutoCancel,
      standardTime: standardTime,
      standardUnit: finalStandardUnit,
      standardReserveCount: standardReserveCount
    }

    onSave(requestData);
  }
  
  return (
    <TopLevelWrapper translateX={translateX}>
      <InfoView>
        <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{clickEditLessonData ? t('settingClasses.editLesson') : t('settingClasses.addLesson')}</Text>
        <ComponentTotalWrapper>
          <ComponentWrapper>
            <ComponentTitleWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.lessonName')}</Text>
              {/* <UnVisibleWrapper>
                <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>수업 비공개</Text>
                <UnVisibleCheckBox isClicked={isLessonUnVisible} onClick={() => setIsLessonUnVisible(!isLessonUnVisible)} />
              </UnVisibleWrapper> */}
            </ComponentTitleWrapper>
            <NewLessonNameInput value={lessonName} setValue={setLessonName} placeholder={t('settingClasses.lessonNamePlaceholder')} />
          </ComponentWrapper>

          <ComponentRowWrapper>
            <ComponentHalfWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.deduction')}</Text>
              <NewCountInput value={deduction} setValue={setDeduction} unit={t('settingClasses.unitSession')} />
            </ComponentHalfWrapper>

            <ComponentHalfWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.capacity')}</Text>
              <NewCountInput value={maxBookedCount} setValue={setMaxBookedCount} unit={t('settingClasses.unitPerson')} />
            </ComponentHalfWrapper>
          </ComponentRowWrapper>

          <ComponentWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.coach')}</Text>
            <NewCoachSelectBox value={teacherData} setValue={setTeacherData} teacherId={teacherId} setTeacherId={setTeacherId} />
          </ComponentWrapper>
          <ComponentWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.visibility')}</Text>
            <LessonHideSelectBox isHide={isHide} setIsHide={setIsHide}/>
          </ComponentWrapper>
          <ComponentWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.tagColor')}</Text>
            <NewColorChoice selectedColor={selectedColor} setSelectedColor={setSelectedColor} />
          </ComponentWrapper>

          <ComponentWrapper style={{ marginTop: '8px' }}>
            <ComponentTitleWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.autoCancel')}</Text>
              <UnVisibleWrapper onClick={() => setIsUseAutoCancel(!isUseAutoCancel)} >
                <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='pointer'>{isUseAutoCancel ? t('settingClasses.autoCancelOn') : t('settingClasses.autoCancelOff')}</Text>
                <UnVisibleCheckBox isClicked={isUseAutoCancel} />
              </UnVisibleWrapper>
            </ComponentTitleWrapper>
            <AutoCancelWrapper style={ isUseAutoCancel ? {opacity: 1} : {opacity: 0}}>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.classStart')}</Text>
              <AutoCancelInputWrapper>
                <NewLessonNameInput value={standardTime} setValue={setStandardTime} placeholder='0' />
              </AutoCancelInputWrapper>
              <AutoCancelSelectBoxWrapper>
                <AutoCancelSelectBox value={standardUnit} setValue={setStandardUnit}/>
              </AutoCancelSelectBoxWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.beforeBookingCount')}</Text>
              <AutoCancelInputWrapper>
                <NewLessonNameInput value={standardReserveCount} setValue={setStandardReserveCount} placeholder='0' />
              </AutoCancelInputWrapper>
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('settingClasses.orFewer')}</Text>
            </AutoCancelWrapper>
          </ComponentWrapper>
        </ComponentTotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExitAddLessonEdit}>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={14} color={theme.gray} cursor='pointer'>{t('settingClasses.cancel')}</Text>
          </ExitButton>
          <SaveButton onClick={onClickSave}>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('settingClasses.save')}</Text>
          </SaveButton>
        </ButtonWrapper>
      </InfoView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 495px;
  min-width: 495px;
  max-width: 495px;
  // height: 454px;
  // height: 538px;
  // height: 570px;
  height: 617px;
  
  z-index: 3;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);

  transform: translateX(${props => props.translateX}px);
  transition: all 0.3s ease-in-out;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 92.12%;
`;

const ComponentTotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 14px;

  width: 100%;

  // gap: 12px;
  gap: 20px;
`;

const ComponentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const ComponentHalfWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 49.34%;

  gap: 8px;
`;

const ComponentTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const AutoCancelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;

  transition: all 0.3s ease-in-out;
`;

const AutoCancelInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // width: 84px;
  width: 74px;
`;

const AutoCancelSelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 72px;
`;

const UnVisibleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;

  &:hover {
    cursor: pointer;
  }
`;

const UnVisibleCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 14px;
  height: 14px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 4px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  // margin-top: 58px;
  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 10px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0 37px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }
`;